/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendTypesEnum } from './BackendTypesEnum';
import {
    BackendTypesEnumFromJSON,
    BackendTypesEnumFromJSONTyped,
    BackendTypesEnumToJSON,
} from './BackendTypesEnum';

/**
 * 
 * @export
 * @interface AccountLightSchema
 */
export interface AccountLightSchema {
    /**
     * 
     * @type {number}
     * @memberof AccountLightSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AccountLightSchema
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLightSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AccountLightSchema
     */
    avatarUrl: string;
    /**
     * 
     * @type {BackendTypesEnum}
     * @memberof AccountLightSchema
     */
    activeBackend?: BackendTypesEnum;
}

/**
 * Check if a given object implements the AccountLightSchema interface.
 */
export function instanceOfAccountLightSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "avatarUrl" in value;

    return isInstance;
}

export function AccountLightSchemaFromJSON(json: any): AccountLightSchema {
    return AccountLightSchemaFromJSONTyped(json, false);
}

export function AccountLightSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountLightSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'slug': json['slug'],
        'name': json['name'],
        'avatarUrl': json['avatar_url'],
        'activeBackend': !exists(json, 'active_backend') ? undefined : BackendTypesEnumFromJSON(json['active_backend']),
    };
}

export function AccountLightSchemaToJSON(value?: AccountLightSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'slug': value.slug,
        'name': value.name,
        'avatar_url': value.avatarUrl,
        'active_backend': BackendTypesEnumToJSON(value.activeBackend),
    };
}

